<template>
  <v-data-table
      :headers="headers"
      :items="mem"
      :items-per-page="15"
      :single-expand="singleExpand"
      :search="search"
      sort-by="mNbr"
      item-key="mNbr"
      dense
      class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
        ></v-text-field>

        <v-dialog v-model="dialog" max-width="800px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                @click="activate"
            >Add Member
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.firstName" label="First name"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="editedItem.surName" label="Last name"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="5">
                    <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-toolbar>
    </template>
    <template v-slot:item.mNbr="{ item }">
      {{ item.active ? item.mNbr : item.mNbr+' *'}}
    </template>
    <template v-slot:Deleteitem.firstName="{ item }">
      {{ item.firstName + ' ' + item.surName }}
    </template>
    <template v-slot:item.memberSince="{ item }">
      {{ $iso2AU(item.memberSince) }}
    </template>
    <template v-slot:item.renewedThru="{ item }">
      {{ $iso2AU(item.renewedThru) }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
          small
          class="mr-2"
          @click="fullEditItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
          small
          @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</template>

<script>

export default {
  name: 'MbrTbl',
  components: {},
  props: {
    mem: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    search: '',
    dialog: false,
    expanded: [],
    singleExpand: false,
    headers: [
      {
        text: 'Member',
        align: 'start',
        sortable: true,
        value: 'mNbr'
      },
      {text: 'Name', value: 'fullName'},
      {text: 'Email', value: 'email'},
      {text: 'Joined', value: 'memberSince'},
      {text: 'Expiration', value: 'renewedThru'},
      {text: 'Address', value: 'street'},
      {text: 'City', value: 'city'},
      {text: 'State', value: 'state'},
      {text: 'Country', value: 'country'},
      {text: 'Actions', value: 'actions', sortable: false},
      {text: '', value: 'data-table-expand'}
    ],
    editedIndex: -1,
    editedItem: {
      firstName: '',
      surName: '',
      email: '',
      phone: '',
      street: '',
      city: '',
      state: '',
      country: ''
    },
    defaultItem: {
      firstName: '',
      surName: '',
      email: '',
      phone: '',
      street: '',
      city: '',
      state: '',
      country: ''
    },
    savedItem: '',
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add Member' : 'Edit Member'
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  created() {
    this.initialize()
  },
  methods: {
    initialize() {
      // console.log('initialize()')
    },
    activate() {
      this.editedIndex = -1
      this.dialog = true
    },
    joined(dt) {
      this.editedItem.memberSince = dt
    },
    editItem(item) {
      this.editedIndex = this.mem.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    fullEditItem(item) {
      this.editedIndex = this.mem.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.savedItem = Object.assign({}, item)
      this.$emit('beginFullEdit', item)
    },
    deleteItem(item) {
      //const index = this.mem.indexOf(item)
      // if(confirm('Are you sure you want to deactivate this member?') && this.mem.splice(index, 1)) {
      if(confirm('Are you sure you want to deactivate this member?')) {
        item.active = false
        this.$http.post(this.$remote + '/api/modmbr', {mbr: item, token: this.$usrStore.token})
            .then(response => {
              this.$usrStore.token = response.data.token
              alert(`Member ${response.data.mbr.fullName} has been marked inactive`)
            })
            .catch(reason => {
              alert(`Could not deactivate the member. Response from server was ${reason}`)
            })
      }
    },
    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    save() {
      if((!this.editedItem.email) || (this.editedItem.email.trim()=='')){
        alert('First name, Last name and Email are required')
        return
      }
      if((!this.editedItem.firstName) || (this.editedItem.firstName.trim()=='')){
        alert('First name, Last name and Email are required')
        return
      }
      if((!this.editedItem.surName) || (this.editedItem.surName.trim()=='')){
        alert('First name, Last name and Email are required')
        return
      }
      if (this.editedIndex > -1) {
        Object.assign(this.mem[this.editedIndex], this.editedItem)
        this.$http.post(this.$remote + '/api/modmbr', {mbr: this.editedItem, token: this.$usrStore.token})
            .then(response => {
              this.$usrStore.token = response.data.token
              console.log(response)
            }).catch(reason => {
          alert('Could not save the change on the server. Please log in again and retry. Error reported: ' + reason)
        })
      } else {
        this.$http.post(this.$remote + '/api/newmbr', {mbr: this.editedItem, token: this.$usrStore.token})
            .then(response => {
              this.$usrStore.token = response.data.token
              console.log(response)
              const m = response.data.mbr
              this.mem.push(response.data.mbr)
              alert(`Saved new member ${m.fullName} as ${m.mNbr}`)
            }).catch(reason => {
          alert('Could not save the member on the server. Please log in again and retry. Error reported: ' + reason)
        })
      }
      this.close()
    },
  },
}
</script>
